import {Suspense} from 'react'
import type {ConnectedProps} from 'react-redux'
import {connect} from 'react-redux'

import type {AppDispatch} from '../../../actions/types'
import type {State} from '../../../reducers/types'
import {getBuild, getBuildType, getIsStarred} from '../../../selectors'
import type {BuildType} from '../../../services/rest'
import type {BuildId, NormalizedBuild} from '../../../types'

import StarBuild from './StarBuild'
import {starBuild} from './StarBuild.actions'

type Props = {
  buildId: BuildId
  showEmpty?: boolean
  className?: string
}

const mapStateToProps = (state: State, props: Props) => {
  const build: Partial<NormalizedBuild> = getBuild(state, props.buildId) || {}
  const buildType: Partial<BuildType> = getBuildType(state, build.buildType) || {}
  const {projectId} = buildType
  const isStarred = getIsStarred(state, props.buildId)
  return {
    projectId,
    isStarred,
  }
}

const mapDispatchToProps = (dispatch: AppDispatch, props: Props) => ({
  onStar: (starred: boolean) => dispatch(starBuild(props.buildId, starred)),
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(function StarBuildContainer(
  props: Props & ConnectedProps<typeof connector>,
) {
  return (
    <Suspense>
      <StarBuild {...props} />
    </Suspense>
  )
})
